import { captureUtmParams } from "./utils/utmTracker";
import { environmentConfig } from "./environments/environment";

captureUtmParams();

import "./aframe/index";
import "./html/style.scss";
import "./html/transition.scss";
import "./vue/index";
import "./mixpanel";
import "./utils/zendesk";

if (environmentConfig.enableSentry) {
  require("./sentry");
}
